/*
 * @Author: 御坂网络服务 wangweigang@gooagoo.com
 * @Date: 2022-05-05 14:40:07
 * @LastEditors: 御坂网络服务 wangweigang@gooagoo.com
 * @LastEditTime: 2022-05-05 15:05:47
 * @FilePath: \parkinglot-web\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Router from 'vue-router'
import CartNum from 'pages/cart-num/cart-num'
import InvoiceList from 'pages/invoice-list/invoice-list'
import InvoiceDetail from 'pages/invoice-detail/invoice-detail'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: CartNum
    },
    {
      path: '/invoiceList',
      component: InvoiceList
    },
    {
      path: '/InvoiceDetail',
      component: InvoiceDetail
    },
    {
      path: '/InvoicePreview',
      component: () => import('@/pages/invoice-preview')
    },
    {
      path: '/InvoiceExecution',
      component: () => import('@/pages/invoice-execution')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js